import { MINERVA_API_URL } from '@/config';
import { http } from '@/plugins/http';

import * as types from './mutation-types';

export function resetDomainLectures({ commit }) {
  commit(types.RESET_DOMAIN_LECTURES);
}

export function resetDomainLecturesPosition({ commit }) {
  commit(types.RESET_DOMAIN_LECTURES_POSITION);
}

export function setDomainLectures({ commit }, { domainLectures, lectureType }) {
  commit(types.SET_DOMAIN_LECTURES, { domainLectures, lectureType });

  return Promise.resolve(domainLectures);
}

export function fetchDomainVideoLectures({ dispatch }, filters) {
  const videoLectureType = 1;
  return http.get(`${MINERVA_API_URL}/video-lectures/`, { params: filters })
    .then(res => (
      dispatch('setDomainLectures', {
        domainLectures: res.data,
        lectureType: videoLectureType,
      })
    ));
}

export function fetchDomainCardLectures({ dispatch }, filters) {
  const cardLectureType = 2;
  return http.get(`${MINERVA_API_URL}/card-lectures/`, { params: filters })
    .then(res => (
      dispatch('setDomainLectures', {
        domainLectures: res.data,
        lectureType: cardLectureType,
      })
    ));
}

export function fetchLectureLearningElement({ dispatch }, elementId) {
  return http.get(`${MINERVA_API_URL}/learning-elements/${elementId}`)
    .then(res => (
      dispatch('setLearningLearningElement', res.data)
    ));
}

export function setLearningLearningElement({ commit }, learningElement) {
  commit(types.SET_LEARNING_ELEMENT, { learningElement });

  return Promise.resolve(learningElement);
}



// WEBPACK FOOTER //
// ./src/app/domain-lecture/store/actions.js